import React from "react"
import { FeaturedWithTabsContent, IFeaturedContentTab } from "@organic-return/foundation-react/src/components/Blades/FeaturedWithTabsContent"
import { ETabListLayout } from "@organic-return/foundation-react/src/components/Blades/TabbedContentBlade"

const TabbedFeaturedContent = ({ module }) => {

    const fields = module.customFields

    let tabs: IFeaturedContentTab[] = [];

    fields.firstTabTitle && (tabs.push({
        tabTitle: fields.firstTabTitle,
        content: fields.firstTabText,
        image: { url: fields.firstTabImage?.url },
        link: { label: fields.firstTabButton?.text, url: fields.firstTabButton?.href }
    }))

    fields.secondTabTitle && (tabs.push({
        tabTitle: fields.secondTabTitle,
        content: fields.secondTabText,
        image: { url: fields.secondTabImage?.url },
        link: { label: fields.secondTabButton?.text, url: fields.secondTabButton?.href }
    }))

    fields.thirdTabTitle && (tabs.push({
        tabTitle: fields.thirdTabTitle,
        content: fields.thirdTabText,
        image: { url: fields.thirdTabImage?.url },
        link: { label: fields.thirdTabButton?.text, url: fields.thirdTabButton?.href }
    }))

    return (

        <FeaturedWithTabsContent
            className="relative max-w-screen-xl mx-auto py-6 lg:py-20"
            title={fields.title}
            titleHeadingLevel={fields.titleTag}
            subtitle={fields.subtitle}
            tabbedContent={{
                tabs: tabs,
                tabListLayout: ETabListLayout.left,
                tabListItemClassNames: {
                    default: "font-bold uppercase",
                    active: "border-b-4 font-bold uppercase",
                }
            }}
        >
        </FeaturedWithTabsContent>
    )
}

export default TabbedFeaturedContent